export default function EFMicrowave(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M27.5 7H4.5C3.67157 7 3 7.67157 3 8.5V23.5C3 24.3284 3.67157 25 4.5 25H27.5C28.3284 25 29 24.3284 29 23.5V8.5C29 7.67157 28.3284 7 27.5 7Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M22 18H26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 21H26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18 10H7C6.44772 10 6 10.4477 6 11V21C6 21.5523 6.44772 22 7 22H18C18.5523 22 19 21.5523 19 21V11C19 10.4477 18.5523 10 18 10Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="24" cy="13" r="2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
